module.exports = __webpack_public_path__ + "media/application/images/new_logo-29fda90988f202051dce60c19b66fa48.svg";